<template>
  <div class="day-totals-reference mb-4 p-3 bg-white rounded">
    <h5 class="mb-0">Day reference (regular + insurance)</h5>
    <small class="text-muted d-block mb-3">
      Combined billed income for this calendar day. This is a reference only — it is not the amount to match against cash in the drawer.
    </small>

    <p v-if="loading" class="text-muted mb-0">Loading day totals...</p>
    <p v-else-if="!hasTotals" class="text-muted mb-0">Day totals could not be loaded.</p>

    <b-row v-else>
      <b-col cols="12" md="4" class="mb-3 mb-md-0">
        <small class="text-muted d-block">Day income</small>
        <strong>$ {{ formatAmount(totals.income) }}</strong>
      </b-col>
      <b-col cols="6" md="4" class="mb-3 mb-md-0">
        <small class="text-muted d-block">Cash (both lanes)</small>
        <strong>$ {{ formatAmount(cashCc.cash) }}</strong>
      </b-col>
      <b-col cols="6" md="4">
        <small class="text-muted d-block">Credit card (both lanes)</small>
        <strong>$ {{ formatAmount(cashCc.cc) }}</strong>
      </b-col>
      <b-col cols="12" class="mt-3">
        <small class="text-muted d-block">
          Insurance base value (informative)
        </small>
        <span>
          $ {{ formatAmount(insBaseValue.total) }}
          <span v-if="insBaseValue.count">
            — {{ insBaseValue.count }}
            (NP {{ insBaseValue.np.count }} / $ {{ formatAmount(insBaseValue.np.total) }},
            NC {{ insBaseValue.nc.count }} / $ {{ formatAmount(insBaseValue.nc.total) }})
          </span>
        </span>
        <small class="text-muted d-block mt-1">
          Income + base value:
          $ {{ formatAmount(incomePlusBase) }}
        </small>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

const EMPTY_INS = () => ({
  count: 0,
  total: 0,
  np: { count: 0, total: 0 },
  nc: { count: 0, total: 0 },
});

export default {
  name: "DayTotalsReference",
  components: {
    BRow,
    BCol,
  },
  props: {
    dayTotals: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasTotals() {
      return Boolean(this.dayTotals && this.dayTotals.totals);
    },
    totals() {
      return this.dayTotals?.totals || {};
    },
    cashCc() {
      return this.dayTotals?.cash_cc || { cash: 0, cc: 0 };
    },
    incomePlusBase() {
      const income = parseFloat(this.totals.income) || 0
      return income + (parseFloat(this.insBaseValue.total) || 0)
    },
    insBaseValue() {
      const value = this.dayTotals?.ins_base_value;
      if (!value) return EMPTY_INS();
      return {
        count: parseInt(value.count, 10) || 0,
        total: parseFloat(value.total) || 0,
        np: {
          count: parseInt(value.np?.count, 10) || 0,
          total: parseFloat(value.np?.total) || 0,
        },
        nc: {
          count: parseInt(value.nc?.count, 10) || 0,
          total: parseFloat(value.nc?.total) || 0,
        },
      };
    },
  },
  methods: {
    formatAmount(value) {
      const n = parseFloat(value);
      return Number.isFinite(n) ? n : 0;
    },
  },
};
</script>
